import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  f7,
} from 'framework7-react';
import '../styles/login.css';
import '@styles/change-password.css';
import { useEffect, useState } from 'react';
import { getCurrentUser, getDocument, updateDocument } from '../firebase';

function AccountPhonePage() {
  const [phone, setPhone] = useState('');

  useEffect(() => {
    const fetchPhone = async () => {
      console.log('fetchPhone called');
      const user = await getCurrentUser();
      if (!user) {
        console.log('fetchPhone: no authenticated user');
        return;
      }

      try {
        console.log(`Fetching phone for users/${user.uid}`);
        const snap = await getDocument(`users/${user.uid}`);
        console.log('Phone document fetched', { exists: snap.exists(), data: snap.data() });
        if (snap.exists()) {
          const data = snap.data() as { phoneNumber?: string };
          if (data.phoneNumber) setPhone(data.phoneNumber);
        }
      } catch (err) {
        console.error('Error fetching user info', err);
      }
    };

    fetchPhone();
  }, []);

  const handleSave = async () => {
    if (!phone.trim()) {
      f7.dialog.alert('Phone number cannot be empty.');
      return;
    }
    const user = await getCurrentUser();
    if (!user) return;

    f7.dialog.preloader('Saving...');
    try {
      await updateDocument(`users/${user.uid}`, {
        phoneNumber: phone.trim(),
      });

      try {
        const info = localStorage.getItem('userInfo');
        const data = info ? JSON.parse(info) : {};
        data.phoneNumber = phone.trim();
        localStorage.setItem('userInfo', JSON.stringify(data));
      } catch {}

      f7.dialog.close();
      f7.dialog.alert('Phone number updated.', '', () => {
        f7.views.main.router.back();
      });
    } catch (err) {
      f7.dialog.close();
      console.error('Error updating phone number', err);
      f7.dialog.alert('Error updating phone number.');
    }
  };

  return (
    <Page name="account-phone">
      <Navbar className="no-outline">
        <NavLeft>
          <Link back className="cancel-button">Cancel</Link>
        </NavLeft>
        <NavTitle>Edit Phone Number</NavTitle>
        <NavRight>
          <Link className="save-button" onClick={handleSave}>
            Save
          </Link>
        </NavRight>
      </Navbar>

      <form
        className="login-form change-password-form"
        onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="phone-number">Phone number</label>
        <input
          id="phone-number"
          type="tel"
          placeholder="Enter phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </form>
    </Page>
  );
}

export default AccountPhonePage;
